import ApplicationController from './application_controller';

// Connects to data-controller="turbo-frame-polling"
// 一定間隔で最も近い turbo-frame を再読み込みする。生成完了を待つ表示に使う。
export default class extends ApplicationController {
  static values = { interval: { type: Number, default: 5000 } };

  connect() {
    super.connect();

    this.frame = this.element.closest('turbo-frame');
    if (!this.frame) { return; }

    this.timer = setInterval(() => { this.frame.reload(); }, this.intervalValue);
  }

  disconnect() {
    if (this.timer) { clearInterval(this.timer); }
  }
}
